/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Opencontent1Inputs */

const zh_course_opencontent1 = /** @type {(inputs: Course_Opencontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开内容`)
};

const en_course_opencontent1 = /** @type {(inputs: Course_Opencontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Content`)
};

const es_course_opencontent1 = /** @type {(inputs: Course_Opencontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir contenido`)
};

/**
* | output |
* | --- |
* | "Open Content" |
*
* @param {Course_Opencontent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_opencontent1 = /** @type {((inputs?: Course_Opencontent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Opencontent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_opencontent1(inputs)
	if (locale === "en") return en_course_opencontent1(inputs)
	return es_course_opencontent1(inputs)
});
export { course_opencontent1 as "course_openContent" }